/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * The selector component for Calendar
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.0.0
 */
import { Component } from 'react';

import { Select } from '../index';
import { IOptionItemProps } from '../Select/Select';
import {
    CalendarSelectorContainerStyled,
    SelectArrowLeftStyled,
    SelectArrowRightStyled,
    SelectContainerStyled,
} from './styled/CalendarSelectorStyled';

/**
 * @description Props for calendar selector.
 * @interface IRangeDatePickerCalendarSelector
 *
 * @property{kind} Theme param for styling.
 * @property{onArrowClick} Function - change calendar on right / left arrow click.
 * @property{onSelect} Function - change calendar on select.
 * @property{options} Options for selector (months or years).
 * @property{selectDuration} Set month / year selector.
 * @property{selectedOption} Current chosen option.
 */
interface IRangeDatePickerCalendarSelector {
    isDisabled: boolean;
    kind: string;
    onArrowClick: any;
    onSelect: any;
    options: IOptionItemProps[];
    selectDuration: ESelectDuration;
    selectedOption: IOptionItemProps;
}

export enum ESelectDuration {
    month = 'month',
    year = 'year',
}

/**
 * CalendarSelector - stateless Component.
 *
 * Props: IRangeDatePickerCalendarSelector.
 * Render selector for choosing months / years.
 * Based on Selector Component.
 */
class CalendarSelector extends Component<IRangeDatePickerCalendarSelector> {

    render() {
        return (
            <CalendarSelectorContainerStyled>

                <SelectArrowLeftStyled
                    data-selector-arrow='selectArrowLeft'
                    isDisabled={this.props.isDisabled}
                    onClick={() => this.props.onArrowClick(this.props.selectDuration, 'decrease')}
                />
                <SelectContainerStyled>
                    <Select
                        kind="normal"
                        options={this.props.options}
                        selectedOption={this.props.selectedOption}
                        onSelect={(value: IOptionItemProps) => this.props.onSelect(this.props.selectDuration, value)}
                    />
                </SelectContainerStyled>
                <SelectArrowRightStyled
                    data-selector-arrow='selectArrowRight'
                    onClick={() => this.props.onArrowClick(this.props.selectDuration, 'increase')}
                />

            </CalendarSelectorContainerStyled>
        );
    }
}

export default CalendarSelector;
